import EmployeeAssign from "@/models/employeeAssign";

export default class EmployeeAssignFactory {
  static createFromJson(json) {
    return new EmployeeAssign(json);
  }
  static createFromJsonArray(jsonArray) {
    const jsonData = [];
    jsonArray.forEach((item) => {
      jsonData.push(EmployeeAssignFactory.createFromJson(item));
    });

    return jsonData;
  }
}
